import React from 'react';

interface IProps {
  items: Array<{
    name: string | React.ReactElement;
    url?: string;
  }>;
  separator?: string | React.ReactNode;
  type?: 'link' | 'white';
  className?: string;
}

export const Breadcrumb = (props: IProps) => {
  const type = props.type || 'link';
  return (
    <div
      className={`flex-wrap flex ${type === 'link' ? 'gap-x-3' : 'gap-x-2'} text-xs items-center ${
        props.className ?? ''
      }`}
      aria-label="breadcrumb"
    >
      {props.items?.map((breadcrumb, index) => (
        <React.Fragment key={index}>
          {breadcrumb.url ? (
            <a className={`${type === 'link' ? 'text-[#0076D8]' : 'text-white'}`} href={breadcrumb.url}>
              {breadcrumb.name}
            </a>
          ) : (
            <span className=" text-[#54545C]">{breadcrumb.name}</span>
          )}
          {index < props.items.length - 1 && (
            <>
              {props.separator ? (
                props.separator
              ) : (
                <div className="w-0 h-0 border-solid border-l-4 border-t-4 border-b-4 border-r-0 border-transparent border-l-[#a5a5ae]" />
              )}
            </>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
